<div class="d-md-flex align-items-center bg-white p-2">
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{titolo}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{collectionSize}}</span>
    </span>
  <div class="ml-auto mt-3 mt-md-0">
  <button type="button" class="btn btn-warning rounded-pill py-2" (click)='showDeleted()'><i
    class="fas fa-ban font-14 mr-1 text-white"></i>
    <span class="ml-1 text-white font-weight-bold">{{showAllText}}</span>
  </button>
  <!-- Add Contact -->
  <button type="button" (click)="add()" class="btn btn-cyan rounded-pill p-2" ><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
    <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
  </button>
</div>
</div>
<div class="d-md-flex align-items-center border-top bg-white p-3">

  <form [formGroup]="ricercaform" class="input-group">
    <div class="input-group col-md-9 ">
      <div class="input-group-prepend">
        <label class="input-group-text" for="cerca">Cerca</label>
      </div>
      <input formControlName="cerca" type="text"
        name="cerca" class="form-control">
    </div>
    <div class="input-group col-md-3">
      <div class="input-group-prepend ">
        <label class="input-group-text" for="fine">Elementi</label>
      </div>
      <select class="custom-select" (change)="sizeChanged()" formControlName="size">
        <option value="1">1</option>
        <option value="10">10</option>
        <option value="25">25</option>
        <option selected value="50">50</option>
        <option value="100">100</option>
        <option value="200">200</option>
        <option value="500">500</option>
        <option value="1000">1000</option>
      </select>
    </div>
  </form>
  <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
    <button class="btn btn-outline-info rounded-pill" style="width: 100%;" (click)="Search()" type="button">Cerca</button>
  </div>
</div>


<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 no-wrap">
    <thead>
      <tr>
        <th >Prodotto</th>
        <th scope="col">Codice</th>
        <th scope="col">Prezzo</th>
        <th scope="col">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let co of Prodotti | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
        <td (click)='edit(co)'>
          <!-- <img [src]='co.Imagepath' class="rounded-circle mr-2" alt="" height="45" width="45"> -->
          <span class="text-dark font-medium font-16">
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i-feather name="info" class="feather-sm"></i-feather>
            </span>
            {{ co.nome}}
          </span>
        </td>
        <td class="align-middle" (click)='edit(co)'>
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-barcode"></i>
            </span>
            {{ co.codice}}
          </span>
        </td>
        <td class="align-middle " (click)='edit(co)'>
          <span>
            <span class="badge badge-light text-dark rounded-pill font-16 mr-1">
              <i class="fas fa-euro-sign"></i>
            </span>
            {{ co.prezzo}} €
          </span>
        </td>
        <td class="align-middle">
          <a href="javascript:void(0)" class="link font-16 text-info font-medium mr-2" (click)='edit(co)'>
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a *ngIf="co.enabled"  href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='delete(co)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!co.enabled" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='renew(co)'>
            <i-feather name="plus" class="feather-sm"></i-feather>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
<div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
  <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
    [collectionSize]="collectionSize" [pageSize]="pageSize">
  </ngb-pagination>
</div>
